<div>
    <div class="summary-group">
        <div class="summary-title">{{'deposits.detail' | translate | uppercase}}</div>
    </div>
    @if (deposit) {
        <div class="overflow-y-auto overflow-x-hidden">
            <div class="field grid row">
                <div class="row">
                    <div class="col">
                    </div>
                </div>
                <div class="field grid row hrBottom">
                    <div class="row">
                        <div class="col">
                            <span class="sub-title-label" translate>common.amount<span>:</span></span>
                        </div>
                        <div class="col">
                            <span class="value-label">{{formatNumber(deposit.amount) || 0}} {{deposit.currency}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <a [attr.href]="isDepositApproval? '/user/customers/view/'+deposit.customerId+'?agrNum='+deposit.agreementNumber : null">
                                <span class="sub-title-label"
                                      [pTooltip]="isDepositApproval ? 'Click and go to deposits page' : null"
                                      tooltipStyleClass="tooltip-class" tooltipPosition="left"
                                      translate>accounts.agreement_number<span>:</span></span>
                            </a>
                        </div>
                        <div class="col">
                            <a [attr.href]="isDepositApproval? '/user/customers/view/'+deposit.customerId+'?agrNum='+deposit.agreementNumber : null">
                            <span class="value-label"
                                  [pTooltip]="isDepositApproval ? 'Click and go to deposits page' : null"
                                  tooltipStyleClass="tooltip-class"
                                  tooltipPosition="left">{{deposit.agreementNumber}}</span>
                            </a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <span class="sub-title-label" translate>summary.agr_date<span>:</span></span>
                        </div>
                        <div class="col">
                            <span class="value-label">{{deposit.agreementDate}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <span class="sub-title-label" translate>common.status<span>:</span></span>
                        </div>
                        <div class="col">
                            <span class="value-label">{{formatTextCapitalize(getDisplayStatus()) || 'N/A'}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <span class="sub-title-label" translate>deposits.product_name<span>:</span></span>
                        </div>
                        <div class="col">
                            <span class="value-label">{{deposit.productTemplateName}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <span class="sub-title-label" translate>product.id<span>:</span></span>
                        </div>
                        <div class="col">
                            <span class="value-label">{{deposit.productTemplateCode}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <span class="sub-title-label" translate>product.description<span>:</span></span>
                        </div>
                        <div class="col">
                            <span class="value-label">{{deposit.productDescription || deposit.description}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <span class="sub-title-label" translate>tasks.group_id<span>:</span></span>
                        </div>
                        <div class="col">
                            <span class="value-label">{{customerGroupId ||  'N/A'}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <a [attr.href]="isDepositApproval? '/user/customers/view/'+deposit.customerId : null">
                  <span class="sub-title-label"
                        [pTooltip]="isDepositApproval ? 'Click and go to Customers page' : null"
                        tooltipStyleClass="tooltip-class" tooltipPosition="left"><span translate>customer_mngt.customer_id</span>:</span>
                            </a>
                        </div>
                        <div class="col">
                            <a [attr.href]="isDepositApproval? '/user/customers/view/'+deposit.customerId : null">
                    <span class="value-label"
                          [pTooltip]="isDepositApproval ? 'Click and go to Customers page' : null"
                          tooltipStyleClass="tooltip-class"
                          tooltipPosition="left">{{deposit.customerNumber}}</span>
                            </a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <span class="sub-title-label" translate>customer_mngt.customer_name<span>:</span></span>
                        </div>
                        <div class="col">
                            <span class="value-label">{{deposit.customerName}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <span class="title-label">{{'deposits.parameters' | translate | uppercase}}</span>
                </div>
                <div class="field grid row hrBottom">
                    <div class="row">
                        <div class="col">
                            <span class="sub-title-label" translate>common.period<span>:</span></span>
                        </div>
                        <div class="col">
                            <span class="value-label">{{depositPeriodCovertToString()}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <span class="sub-title-label" translate>summary.interest_rate<span>:</span></span>
                        </div>
                        <div class="col">
                            <span class="value-label">{{deposit.interestRateResolved}}%</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <span class="sub-title-label" translate>collaterals.agreement_date<span>:</span></span>
                        </div>
                        <div class="col">
                            <span class="value-label">{{deposit.agreementDate}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <span class="sub-title-label" translate>deposits.granting_date<span>:</span></span>
                        </div>
                        <div class="col">
                            <span class="value-label">{{deposit.fundingDate || '—'}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <span class="sub-title-label" translate>deposits.interest_calculate_opt<span>:</span></span>
                        </div>
                        <div class="col">
                            <span class="value-label">{{findInterestCalculationOptions(deposit.interestCalculationOption)}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col padding-item">
                            <span class="sub-title-label" translate>deposits.maturity_date<span>:</span></span>
                        </div>
                        <div class="col">
                            <span class="value-label">{{deposit.maturityDate}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col padding-item">
                            <span class="sub-title-label" translate>deposits.early_repayment<span>:</span></span>
                        </div>
                        <div class="col">
                            <span class="value-label">{{deposit.earlyWithdrawalAllowed ? "Yes" : "No"}}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col padding-item">
                            <span class="sub-title-label" translate>deposits.early_repayment_fee<span>:</span></span>
                        </div>
                        <div class="col">
                            <span class="value-label">{{deposit.penaltyOnEarlyWithdrawal}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="field grid row">
                <div class="row">
                    <div class="col">
                        <span class="title-label">{{'linked_accounts.title' | translate | uppercase}} </span>
                    </div>
                    <div class="field grid row hrBottom">
                        @if (deposit.linkedAccounts?.length > 0) {
                            @for (account of deposit.linkedAccounts; track account.id || account.role) {
                                <div class="row">
                                    <div class="col">
                                        <span class="sub-title-label">{{formatTextCapitalize(account.role)}}<span>:</span></span>
                                    </div>
                                    <div class="col pl-30">
                                        <span class="value-label">{{account.accountNumber || '—'}}</span>
                                    </div>
                                </div>
                            }
                        }
                        <div class="row">
                            <div class="col">
                                <span class="sub-title-label" translate>accounts.correspondent<span>:</span></span>
                            </div>
                            <div class="col pl-30">
                                <span class="value-label">{{deposit.correspondingAccountNumber || '—'}}</span>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col">
                                <span class="sub-title-label" translate>deposits.interest_correspond_acc<span>:</span></span>
                            </div>
                            <div class="col pl-30">
                                <span class="value-label">{{deposit.interestCorrespondingAccountNumber || '—'}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            @if (deposit.notes?.length > 0) {
                <div class="field grid row">
                    <div class="row">
                        <div class="col">
                            <span class="title-label">{{'common.notes' | translate | uppercase}}</span>
                        </div>
                        <div class="field grid row hrBottom">
                            @for (note of notesHierarchy; track note) {
                                <div class="row">
                                    <div class="col">
                                        <span class="sub-title-label">{{note.parent}}:</span>
                                    </div>
                                    <div class="col pl-30">
                                        <span class="value-label"> {{note.child}}</span>
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }
            <div class="field grid row">
                <div class="row">
                    <div class="col">
                        <div class="title-label">{{'common.add_info' | translate | uppercase}}</div>
                    </div>
                </div>
                <div class="field grid row hrBottom">
                    <div class="row">
                        <div class="col">
                            <span class="sub-title-label" translate>common.description<span>:</span></span>
                        </div>
                        <div class="col">
                            <span class="value-label">{{deposit.description || '—'}}</span>
                        </div>
                    </div>
                    @if (deposit.closingDate) {
                        <div class="row">
                            <div class="col padding-item">
                                <span class="sub-title-label" translate>common.close_date<span>:</span></span>
                            </div>
                            <div class="col">
                                <span class="value-label">{{deposit.closingDate}}</span>
                            </div>
                        </div>
                    }
                    <div class="row">
                        <div class="col padding-item">
                            <span class="sub-title-label" translate>common.branch<span>:</span></span>
                        </div>
                        <div class="col">
                            <span class="value-label">{{getBranchName(deposit.branchCode)}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    }
</div>
